var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-icon',{staticClass:"mr-1",class:_vm.className,attrs:{"icon":_vm.icon}}),_c('span',{class:{'font-weight-bold': _vm.bold}},[_vm._v(_vm._s(_vm.xLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }